import { Link } from 'react-router-dom';
import { footerLinks } from '@/mocks/navigation';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 group">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center transition-transform group-hover:scale-105">
                <span className="text-background-50 font-bold text-sm">88</span>
              </div>
              <span className="text-lg font-semibold text-foreground-950 font-heading">
                8866h.cc
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              安全、稳定、快速的官方平台入口，为您提供优质的服务体验。认准官方域名 8866h.cc，谨防仿冒网站。
            </p>
          </div>

          {Object.values(footerLinks).map((section) => (
            <div key={section.title}>
              <h4 className="text-sm font-semibold text-foreground-950 mb-4">
                {section.title}
              </h4>
              <ul className="space-y-2.5">
                {section.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 8866h.cc 版权所有。保留一切权利。
          </p>
          <p className="text-xs text-foreground-500">
            8866h.cc 官方入口 &mdash; 安全稳定快速访问
          </p>
        </div>
      </div>
    </footer>
  );
}